// src/utils/audioManager.js

let currentAudio = null;

export function playAudio(src, rate = 1.0) {
  if (currentAudio && !currentAudio.paused) {
    currentAudio.pause();
  }

  currentAudio = new Audio(src);
  currentAudio.playbackRate = rate;
  currentAudio.play();

  return currentAudio;
}

export function pauseAudio() {
  if (currentAudio) currentAudio.pause();
}

export function stopAudio() {
  if (currentAudio) {
    currentAudio.pause();
    currentAudio.currentTime = 0;
  }
}

export function setSpeed(rate) {
  if (currentAudio) currentAudio.playbackRate = rate;
}

export function getCurrentAudio() {
  return currentAudio;
}
